export default __webpack_public_path__ + "static/media/video-camera.f0777ecc.png";